import SettingsContent from '../Wrapper';
import Index from './Index';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/csat-survey'),
      component: SettingsContent,
      props: {
        headerTitle: 'CSAT_MGMT.HEADER',
        icon: 'emoji',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'csat_wrapper',
          roles: ['administrator'],
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'csat_survey_list',
          roles: ['administrator'],
          component: Index,
        },
      ],
    },
  ],
};
